
import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { baseApi } from "@store/apis";

import type { Progress, ProgressRequest } from "../GetProgress/models";
import type { ApiResponse } from "../models";

const GetProgressQuery = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GetProgress: builder.query({
      query: ({ page, itemsPerPage, categoryId }: ProgressRequest) => ({
        url: "",
        params: {
          Endpoint: "GetProgressChallenges",
          Page: page,
          ItemsPerPage: itemsPerPage,
          CategoryId: categoryId,
          UserId: secureStorage.get<string>(StorageKeys.USER_ID),
        },
        method: "GET",
      }),
      providesTags: ["Challenges"],
      transformResponse: (response: ApiResponse<Progress>) => response.result,
    }),
  }),
});
export const { useGetProgressQuery } = GetProgressQuery;
